import React, { useState } from "react";
import "../assets/css/ContactForm.css";

const ContactForm = ({ show, handleClose, onSubmit }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isChecked) {
      alert("Você precisa concordar com os termos para continuar.");
      return;
    }

    const formData = {
      name,
      email,
      phone,
      message,
    };

    if (onSubmit) {
      await onSubmit(formData);
    }

    // Limpar formulário
    setName('');
    setEmail('');
    setPhone('');
    setMessage('');
    setIsChecked(false);
  };

  const formatPhone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.replace(/^(\d{2})(\d)/g, "($1) $2");
    value = value.replace(/(\d{5})(\d)/, "$1-$2");
    return value;
  };

  return (
    <div className={`modal fade custom-modal ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog padding-top-19" role="document">
        <div className="modal-content alter-modal">
          <div className="modal-header">
            <p className="modal-custom-title">Formulário para contato</p>
          </div>
          <div className="modal-body text-start">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="formName">Nome Completo</label>
                <input
                  type="text"
                  className="form-control style-input"
                  id="formName"
                  name="name"
                  placeholder="Nome"
                  maxLength={60}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group margin-32">
                <label htmlFor="formPhone">Whatsapp</label>
                <input
                  type="text"
                  className="form-control style-input"
                  id="formPhone"
                  name="phone"
                  placeholder="(DDD) 9 9999-9999"
                  maxLength={15}
                  value={phone}
                  onChange={(e) => setPhone(formatPhone(e.target.value))}
                  required
                />
              </div>
              <div className="form-group margin-32">
                <label htmlFor="formEmail">E-mail Coorporativo</label>
                <input
                  type="email"
                  className="form-control style-input"
                  id="formEmail"
                  name="email"
                  placeholder="exemplo@email.com"
                  maxLength={80}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group margin-32">
                <label htmlFor="formMessage">Como podemos te ajudar?</label>
                <textarea
                  className="form-control"
                  id="formMessage"
                  name="message"
                  maxLength={4000}
                  placeholder="Digite a sua necessidade"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={3}
                  required
                />
              </div>
              <div className="form-group margin-32 text-align-center">
                <input
                  type="checkbox"
                  id="terms"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  required
                  className="custom-checkbox"
                />
                <label htmlFor="terms">
                  Eu concordo com os <a href="/termos">Termos</a> & <a href="/permissoes">Permissões</a>
                </label>
              </div>
              <div className="btnActions margin-32">
                <button type="button" className="btn-cancel width-140" onClick={handleClose}>
                  Cancelar
                </button>
                <button type="submit" disabled={!isChecked} className="btn-next width-140">
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;